import React from "react";
import { Text, StyleSheet, Font, View } from "@react-pdf/renderer";
import { GetDonation } from "./DonationContextProvider";
import BookmanOldStyleBold from "./fonts/BOOKOSB.TTF";

Font.register({
  family: "Bookman Old Style",
  fonts: [{ src: BookmanOldStyleBold, fontWeight: "bold" }],
});

const styles = StyleSheet.create({
  textHeader: {
    width: "100%",
    color: "#1E79F4",
    paddingBottom: "0.5vh",
  },
  viewStyle: {
    flexDirection: "column",
  },
  textHeaderTop: {
    fontFamily: "Bookman Old Style",
    fontWeight: "bold",
    fontSize: "18px",
  },
  textHeaderOther: {
    fontFamily: "Bookman Old Style",
    fontWeight: "bold",
    fontSize: "12px",
  },
  textHeaderSmallFont: {
    fontFamily: "Bookman Old Style",
    fontWeight: "normal",
    fontSize: "7px",
  },
});
function LogoHeaderText() {
  const donation = GetDonation();
  const trust = donation.trust;
  return (
    <>
      <View style={styles.viewStyle}>
        <Text style={[styles.textHeader, styles.textHeaderTop]}>
          {trust === "CREST"
            ? "Chaitanya Research & Educational Services Trust"
            : "Shree Chaitanya Shikshan Samstha"}
        </Text>
        <Text style={[styles.textHeader, styles.textHeaderTop]}>
          {trust === "CREST" ? "(CREST)" : "(SCSS)"}
        </Text>
        <Text
          style={[
            styles.textHeader,
            styles.textHeaderOther,
            { flexWrap: "nowrap" },
          ]}
        >
          {trust === "CREST"
            ? "Flat No B601, Golok Vrindavan, Tilekar Nagar, Behind ISKCON Temple, Kondhwa Pune - 48"
            : "4, Tarapore Road, Camp, Pune - 01"}
        </Text>
        <Text style={[styles.textHeader, styles.textHeaderOther]}>
          {trust === "CREST"
            ? "Registered under Soc Reg Act 1860 No MH.894/2015/PUNE"
            : "Registered under Soc Reg Act 1860 No MH.1972/2007/PUNE"}
        </Text>
        <Text style={[styles.textHeader, styles.textHeaderOther]}>
          {trust === "CREST"
            ? "Trust PAN: AABTC8218M"
            : "Trust PAN: AAKTS9670C"}
        </Text>
        <Text style={[styles.textHeader, styles.textHeaderOther]}>
          {(() => {
            const donationDate = new Date(donation.date);
            const cutoffDate = new Date("2026-03-31T23:59:59.999");
            if (donationDate <= cutoffDate) {
              // On or before 31 March 2026
              return trust === "CREST"
                ? "80G Unique Reg No: AABTC8218MF20211"
                : "80G Unique Reg No: AAKTS9670CF20217";
            } else {
              // After 31 March 2026
              return trust === "CREST"
                ? "80G Unique Reg No: AABTC8218M25PN02"
                : "80G Unique Reg No: AAKTS9670C25PN02";
            }
          })()}
        </Text>
        {process.env.REACT_APP_IS_PROD === "false" && (
          <>
            <Text style={[styles.textHeader, styles.textHeaderSmallFont]}>
              This is a sample receipt and not a valid one. This doesn't have
              any legal stand.
            </Text>
          </>
        )}
      </View>
    </>
  );
}

export default LogoHeaderText;
